import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AuraNotification {
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notificationSubject = new Subject<AuraNotification | null>();
  state$ = this.notificationSubject.asObservable();

  show(message: string, type: 'success' | 'error' | 'info' = 'success', duration: number = 4000) {
    this.notificationSubject.next({ message, type, duration });

    setTimeout(() => {
      this.notificationSubject.next(null);
    }, duration);
  }
}
